import { Seg } from "@kitchen/ui";
import { useState } from "react";
import { AccountsTab } from "./AccountsTab.js";
import { VouchersTab } from "./VouchersTab.js";
import { ReportsTab } from "./ReportsTab.js";
import { SettingsTab } from "./SettingsTab.js";
import { FiscalYearsTab } from "./FiscalYearsTab.js";

export type AccountingTab = "accounts" | "vouchers" | "reports" | "settings" | "fiscal-years";

export function AccountingPage() {
  const [tab, setTab] = useState<AccountingTab>("accounts");

  return (
    <div className="stack" style={{ gap: "var(--s4)" }}>
      <div className="row wrap" style={{ alignItems: "center" }}>
        <Seg<AccountingTab>
          label="بخش حسابداری دوبل و اسناد"
          value={tab}
          onChange={setTab}
          options={[
            { value: "accounts", label: "سرفصل حساب‌ها" },
            { value: "vouchers", label: "اسناد حسابداری" },
            { value: "reports", label: "دفاتر و تراز" },
            { value: "settings", label: "تنظیمات" },
            { value: "fiscal-years", label: "سال مالی" },
          ]}
        />
      </div>

      {tab === "accounts" && <AccountsTab />}
      {tab === "vouchers" && <VouchersTab />}
      {tab === "reports" && <ReportsTab />}
      {tab === "settings" && <SettingsTab />}
      {tab === "fiscal-years" && <FiscalYearsTab />}
    </div>
  );
}

export * from "./AccountsTab.js";
export * from "./VouchersTab.js";
export * from "./ReportsTab.js";
export * from "./SettingsTab.js";
export * from "./FiscalYearsTab.js";
